query getLeadsStatusesStatistics($input: GetLeadsStatusesStatisticsInput!) {
    getLeadsStatusesStatistics: getLeadsStatusesStatistics(input: $input) {
        companyName
        companyId
        statuses {
           status
           count
        }
    }
}
